export const common = {
  loading: "Loading...",
  save: "Save",
  saved: "Saved.",
  cancel: "Cancel",
  edit: "Edit",
  delete: "Delete",
  add: "Add",
  search: "Search",
  close: "Close",
  submit: "Submit",
  showMore: "Show more",
  showLess: "Show less",
  back: "Back",
  prev: "Prev",
  next: "Next",
  page: "Page",
  yes: "Yes",
  no: "No",
  confirm: "Confirm",
  undo: "Undo",
  noResults: "No results.",
  results: "Results",
  showingRange: "Showing {from}–{to} of {total}",
  searchPlaceholder: "Enter website title, description, URL or category...",
  genericError: "Something went wrong. Please try again.",
  tooManyRequests: "Too many requests. Please try again later.",
  invalidRequest: "Invalid request.",
  sessionExpired: "Session expired.",
  accessDenied: "Access denied.",
  notFound: "Not found.",
  serverError: "Server error.",
  serviceStarting:
    "The service is still starting. Please wait a few seconds and try again.",
  errorWithStatus: "Error ({status}).",
  noConnection: "No connection to the server.",
  unexpectedError: "An unexpected error occurred.",
  validationError: "Please check your input and try again.",
  externalLinkWarningTitle: "You are leaving WebKurator.de",
  externalLinkWarningBody:
    "We are not responsible for the content of external websites and cannot verify all URLs entered on our platform. Proceed with caution.",
  externalLinkWarningDoNotShowAgain: "Do not show this warning again.",
  externalLinkWarningProceed: "Proceed anyway",
};

export const header = {
  title: "WebKurator.de",
  subtitle: "University of Passau",
  home: "Home",
  categories: "Categories",
  statistics: "Statistics",
  search: "Search",
  messages: "Messages",
  tickets: "Tickets",
  suggest: "Suggest",
  manage: "Manage",
  administration: "Administration",
  login: "Login",
  register: "Register",
  logout: "Logout",
  myAccount: "My Account",
  darkMode: "Dark Mode",
  lightMode: "Light Mode",
  decreaseUiScale: "Decrease UI scale",
  increaseUiScale: "Increase UI scale",
};

export const footer = {
  about: "About WebKurator",
  aboutText: "WebKurator.de is a University of Passau project for the systematic collection and categorization of German websites for archival and research purposes.",
  quickLinks: "Quick Links",
  legal: "Legal",
  legalNotice: "Legal Notice",
  privacy: "Privacy",
  terms: "Terms of Service",
  help: "Help",
  contact: "Contact",
  copyright: "© 2026 University of Passau. All rights reserved.",
};
